<p-toggleswitch class="caremoni-switch-button"   [style.--scale-dpad]="scaledpad"
  [attr.dpad]="dpad"
  [attr.x-dpad]="xdpad" 
  [attr.y-dpad]="ydpad" 
  [attr.x-tab-dpad]="xtabdpad" 
  [attr.y-tab-dpad]="ytabdpad" 
  [attr.tab-dpad]="tabdpad" [(ngModel)]="checked" (onChange)="onChangeData($event)" [dt]="switchConfig"/>